export const cartItemCardStyles = {
  root: 'rounded-lg border border-brand-700/20 bg-surface p-4 md:p-5',
  rootInvalid: 'border-2 border-red-500',
  layout: 'flex gap-4',
  thumb: 'h-24 w-24 shrink-0 overflow-hidden rounded-md bg-brand-100 sm:h-28 sm:w-28',
  thumbImg: 'h-full w-full object-cover',
  body: 'flex min-w-0 flex-1 flex-col gap-3',
  top: 'flex items-start justify-between gap-3',
  title: 'font-heading text-heading-sm text-brand-950 line-clamp-2 sm:text-heading-md',
  titleLink: 'transition-colors hover:text-brand-600',
  meta: 'mt-1 space-y-1 font-sans text-sm text-brand-700',
  invalid: 'rounded-md bg-red-100 p-2 font-sans text-sm text-red-800',
  actions:
    'mt-auto flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between',
  qtyPrice: 'flex flex-wrap items-end gap-4',
  priceCol: 'flex flex-col gap-0.5',
  subtotal: 'font-sans text-sm text-brand-700',
} as const;
